import useSeason from '@/hooks/useSeason';
import cn from '@/lib/cs';
import { motion } from 'framer-motion';

const SeasonIllustrationBackground = ({
	className,
	children,
}: {
	className?: string;
	children: React.ReactNode;
}) => {
	const season = useSeason();

	return (
		<div
			className={cn('fixed inset-0 size-full', className)}
			style={{
				backgroundColor: 'var(--color-primary)',
				backgroundImage: `url(/assets/backgrounds/${season}.svg)`,
				backgroundSize: 'cover',
				width: '100lvw',
				height: '100lvh',
			}}
		>
			<motion.div
				className="fixed inset-0 size-full bg-black"
				initial={{
					opacity: 0.15,
				}}
				animate={{
					opacity: 0.25,
				}}
				transition={{
					duration: 4,
				}}
			/>
			<motion.div
				className="fixed inset-0 size-full bg-primary"
				initial={{
					opacity: 0,
				}}
				animate={{
					opacity: 0.05,
				}}
				transition={{
					duration: 6,
				}}
			/>
			{children}
		</div>
	);
};

export default SeasonIllustrationBackground;
